import React, { FC } from 'react';

import { ItemLink } from '../../../types/banner';
import { getType } from '../../../utils.v2';
import { ItemLinkType } from '../../../constants';
import { Link } from '../Common';

interface BannerLinkProps {
  link: ItemLink;
  onClick: () => void;
}

export const BannerLink: FC<BannerLinkProps> = ({ link, onClick, children }) => {
  const { isClock } = getType()
  const { resourceId, type } = link;
  let to;

  if (type === ItemLinkType.URL) {
    to = resourceId;

    if (to && !to.startsWith('/')) {
      // External link
      /* eslint-disable jsx-a11y/anchor-has-content */
      return (
        <a
          href={resourceId}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClick}
        >{children}</a>
      );
      /* eslint-enable jsx-a11y/anchor-has-content */
    }
  }

  const urlPrefix = isClock ? 'clock' : 'app';

  if (type === ItemLinkType.APP) {
    to = `/v2/${urlPrefix}/${resourceId}`;
  } else if (type === ItemLinkType.CATEGORY) {
    to = `/v2/${urlPrefix}s/category/${resourceId}`;
  } else if (type === ItemLinkType.COLLECTION) {
    to = `/v2/${urlPrefix}s/collection/${resourceId}`;
  }

  return <Link
    to={to}
    pageDirection="FORWARD"
    onClick={onClick}
    id={`banner-link-${resourceId}`}
  >{children}</Link>;
};